import React, { createContext, useContext, useState, useCallback } from 'react';

const ToolTabContext = createContext(null);

export function ToolTabProvider({ children }) {
  const [isOpen, _setOpen]   = useState(false);
  const [panels, setPanels]  = useState([]);
  const [activePanel, setActivePanel] = useState(null);
  const [header, setHeader] = useState(null);
  const [layout, setLayout] = useState('tabs'); // 'tabs' | 'stack'(위젯 카드 형태로 모든 패널을 동시에 표시)

  const setOpen = useCallback((open) => {
    _setOpen(open);
    // body 클래스: ToolTabContainer CSS 오프셋에 활용
    document.body.classList.toggle('tool-tab-open', open);
  }, []);

  const registerPanels = useCallback((newPanels, options = {}) => {
    const normalizedPanels = Array.isArray(newPanels) ? newPanels : [];
    setPanels(normalizedPanels);
    setHeader(options.header ?? null);
    setLayout(options.layout ?? 'tabs');
    setActivePanel((prev) =>
      normalizedPanels.some((panel) => panel.id === prev)
        ? prev
        : normalizedPanels[0]?.id ?? null
    );
  }, []);

  const clearPanels = useCallback(() => {
    setPanels([]);
    setActivePanel(null);
    setHeader(null);
    setLayout('tabs');
    setOpen(false);
  }, [setOpen]);

  return (
    <ToolTabContext.Provider value={{
      isOpen, setOpen,
      panels, activePanel, setActivePanel,
      header, layout,
      registerPanels, clearPanels,
    }}>
      {children}
    </ToolTabContext.Provider>
  );
}

export function useToolTab() {
  const ctx = useContext(ToolTabContext);
  if (!ctx) throw new Error('useToolTab must be used inside ToolTabProvider');
  return ctx;
}
